"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidationError = exports.isPasswordReuseError = void 0;
const ServiceErrors_1 = require("../constants/ServiceErrors");
function isPasswordReuseError(code) {
    return code === ServiceErrors_1.ERROR_ACCOUNT_PASSWORD_RESUSE;
}
exports.isPasswordReuseError = isPasswordReuseError;
function isValidationError(code) {
    // Handles general validation error codes
    return code === ServiceErrors_1.ERROR_ACCOUNT_VALIDATION_FAILURE;
}
exports.isValidationError = isValidationError;
//# sourceMappingURL=ValidationUtils.js.map